import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { FadeAnimation } from '@app/core/animations/fade.transition';
import { SubFilter } from '@app/core/models/common.models';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { ListItem, SelectorTranslationTexts } from '../../models/selector.model';

@Component({
  standalone: false,
  selector: 'adspt-global-filter-selector-list',
  templateUrl: './global-filter-selector-list.component.html',
  styleUrls: ['./global-filter-selector-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [FadeAnimation],
})
export class GlobalFilterSelectorListComponent implements OnChanges {
  @Input() hasAdvancedMode = false;
  @Input() enabledApplySection = true;
  @Input() disableResetActions = false;
  @Input() isDestinationFilterMode = true;
  @Input() selectedItem: ListItem;
  @Input() heapInfo: any = {};
  @Input() count = '';
  @Input() loading = false;
  @Input() subfilterOptions = [] as SubFilter[];
  @Input() defaultSubfiltersValues: string;
  @Input() texts: SelectorTranslationTexts = <SelectorTranslationTexts>{};
  @Input() data: ListItem[];
  @Input() public template: TemplateRef<any>;
  @Output() refinerChange = new EventEmitter();
  @Output() notfiy = new EventEmitter();

  @HostListener('scroll', ['$event']) onScroll({ target }: any) {
    if (Math.ceil(target.offsetHeight + target.scrollTop + 1) >= target.scrollHeight) {
      this.notfiy.emit({ type: 'SCROLL' });
    }
  }

  showingAdvancedMode = true;
  formCtrl = new FormControl();
  currentFilter;

  onSubFilterChange({ filters, param }) {
    this.currentFilter = param;
    this.refinerChange.emit({ type: 'FILTER', filters });
  }

  onAdvancedMode() {
    this.formCtrl.setValue(null);
    this.showingAdvancedMode = !this.showingAdvancedMode;

    this.elementRef.nativeElement.querySelector('.items-list').scrollTo(0, 0);

    if (!this.showingAdvancedMode) this.refinerChange.emit({ type: 'SEARCH', query: null });
    else {
      this.subfilterOptions.forEach((d) => (d.isAdded = false));
      this.refinerChange.emit({ type: 'FILTER' });
    }
  }

  constructor(private elementRef: ElementRef) {
    this.formCtrl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((query) => {
      if (query !== null && query !== undefined) {
        this.refinerChange.emit({ type: 'SEARCH', query });
      }
    });
  }

  canScrollForNewItems(data) {
    return (
      !!data && data?.currentValue && data?.previousValue && data?.currentValue.length > data?.previousValue.length
    );
  }

  scrolltoNextItem() {
    const ele = this.elementRef.nativeElement.querySelector('.items-list');
    setTimeout(() => {
      ele.scrollBy({ top: 50, behavior: 'smooth' });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.canScrollForNewItems(changes?.data)) this.scrolltoNextItem();

    if (changes.hasAdvancedMode && !this.hasAdvancedMode) this.refinerChange.emit({ type: 'FILTER', filters: [] });
  }
}
